import React from "react";
import {cx} from "../../lib/ClassSet";
import ContextMenuTrigger from "../../components/ContextMenuTrigger";

const PackageItem = (props) => {

  let {data} = props;

  let classes = cx({
    "item": true,
    "shipping-order-package-list-item": true,
    "u-selected": props.selected
  })
  let inventory = data.get("inventory").map(x => {
    return <span key={x.get("sku")}>{x.get("title")} ({x.get("sku")})</span>
  })
  let packaging = data.get("packaging").map(x => {
    return <span key={x.get("sku")}>{x.get("title")} ({x.get("sku")})</span>
  })
  let content = inventory.concat(packaging).toJS()
  let contextClickFn = (x, y) => props.onContextMenuClick(data, x, y)

  return (
    <tr className={classes}>
      <td className="field">{data.get("dimensions")}<br/>{data.get("weight")}</td>
      <td className="field">{content}</td>
      <td className="field f-context"><ContextMenuTrigger active={true} onClick={contextClickFn}/></td>
    </tr>
  )
}

export default PackageItem;